export const GET_STATIC_PAGE_CONTENT = 'staticPages/GET_STATIC_PAGE_CONTENT';



// WEBPACK FOOTER //
// ./src/redux/StaticPages/constants.js